function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 19.44C19.4867 19.44 18.58 19.84 17.8867 20.4666L8.38 14.9333C8.44667 14.6266 8.5 14.32 8.5 14C8.5 13.68 8.44667 13.3733 8.38 13.0666L17.78 7.58663C18.5 8.25329 19.4467 8.66663 20.5 8.66663C22.7133 8.66663 24.5 6.87996 24.5 4.66663C24.5 2.45329 22.7133 0.666626 20.5 0.666626C18.2867 0.666626 16.5 2.45329 16.5 4.66663C16.5 4.98663 16.5533 5.29329 16.62 5.59996L7.22 11.08C6.5 10.4133 5.55333 9.99996 4.5 9.99996C2.28667 9.99996 0.5 11.7866 0.5 14C0.5 16.2133 2.28667 18 4.5 18C5.55333 18 6.5 17.5866 7.22 16.92L16.7133 22.4666C16.6467 22.7466 16.6067 23.04 16.6067 23.3333C16.6067 25.48 18.3533 27.2266 20.5 27.2266C22.6467 27.2266 24.3933 25.48 24.3933 23.3333C24.3933 21.1866 22.6467 19.44 20.5 19.44Z",
  fill: "#424242"
});

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.ec401730.svg";
export { ForwardRef as ReactComponent };